import { useState } from 'react';

/**
 * Manages collapse/expand state for collapsible lists
 * Used by: OrgRegistryManagement, OrgTechContextSetup
 * Handles expanded keys and toggle logic
 */
export const useCollapseState = () => {
  const [expandedKeys, setExpandedKeys] = useState([]);

  const expandAll = (list) => {
    setExpandedKeys(list.map((item) => item.function_key));
  };

  const collapseAll = () => {
    setExpandedKeys([]);
  };

  return {
    expandedKeys,
    setExpandedKeys,
    expandAll,
    collapseAll,
  };
};
